import React, { FC } from "react";
import RegisterForm from "../molecules/RegisterForm";
import '../../static/css/Register.css'
import AuthCard from "../atoms/AuthCard";


const RegisterPage: FC = () => {
  return (
    <>
      <AuthCard
       
       title="Register"
       form={<RegisterForm />}
 
      />

    </>
  );
};
export default RegisterPage;
